const dataSlider = [
  {
    id: 0,
    title: 'Lorem ipsum',
    subTitle: 'Lorem',
  },
  {
    id: 1,
    title: 'Lorem ipsum',
    subTitle: 'Lorem',
  },
  {
    id: 2,
    title: 'Lorem ipsum',
    subTitle: 'Lorem',
  },
  {
    id: 3,
    title: 'Lorem ipsum',
    subTitle: 'Lorem',
  },
];

export default dataSlider;
